module.exports = __webpack_public_path__ + "img/zz-b.0067a99d.png";